import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router";
import { useWorkspaceStore } from "@/store/workspace-store";

// Renders the sticky `← Settings` back link on mobile section pages so the
// user can return to the settings menu. The section itself still owns its
// own H1 — this header only adds the wayfinding chrome.
export function SettingsMobileSectionHeader() {
  const { workspaceId: urlWorkspaceId } = useParams<{
    workspaceId: string;
  }>();
  const { activeWorkspace } = useWorkspaceStore();
  const workspaceId = urlWorkspaceId || activeWorkspace?._id;

  return (
    <header className="sticky top-0 z-20 flex h-12 shrink-0 items-center border-b border-border bg-background/95 px-3 backdrop-blur supports-[backdrop-filter]:bg-background/80">
      <Link
        to={`/${workspaceId}/settings`}
        className="flex h-9 items-center gap-1.5 rounded px-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Back to Settings menu"
      >
        <ArrowLeft className="h-4 w-4" />
        Settings
      </Link>
    </header>
  );
}
